
export class TargetSourceAttributeFilterOptions {
    targetObjectAttributeIds: Array<number>;
    sourceObjectAttributeIds: Array<number>;
    targetObjectIds: Array<number>;
    sourceObjectIds: Array<number>;
}
